import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ProductCard } from "@/components/ProductCard";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export default function Wishlist() {
  const { user } = useAuth();
  const [products, setProducts] = useState(null);
  const ids = (user?.wishlist_ids || []).join(",");
  useEffect(() => { api.get("/wishlist").then((r) => setProducts(r.data)); }, [ids]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-12" data-testid="wishlist-page">
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#FF3B30] font-semibold mb-2">Saved for later</p>
      <h1 className="font-display font-black uppercase tracking-tight text-4xl sm:text-5xl">Wishlist</h1>
      {products?.length === 0 && (
        <p data-testid="wishlist-empty" className="text-neutral-400 mt-10">Nothing saved yet. Tap the heart on any product. <Link to="/shop" className="text-white underline">Browse the shop</Link>.</p>
      )}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mt-10">
        {products?.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
      </div>
    </div>
  );
}
